import { Deserializable } from '../protocols/deserializable';
import { LifeStatusTypeIdEnum } from './enum/life-status-type-id.enum';
import { LifeStatusType } from './life-status-type';

export class MemberLifeStatus implements Deserializable {
  public id!: number;
  public memberId!: number;
  public lifeStatusId!: LifeStatusTypeIdEnum;
  public lifeStatus!: LifeStatusType;
  public effectiveDate!: string;
  public paymentsIssuedToEstate: boolean = false;
  // TODO: SPP-3262 confirm the field name once the API returns it
  public hasDeathRecord: boolean = false;

  public onDeserialize(): void {
    if (this.lifeStatus) {
      this.lifeStatus = window?.injector?.Deserialize?.instanceOf(LifeStatusType, this.lifeStatus);
    }
  }
}
